export function applyMinuteInterval(date, interval = 15) {
    date.setSeconds(0);
    date.setMilliseconds(0);
    date.setMinutes(Math.ceil(date.getMinutes()/interval)*interval);
    return date;
}